export default __webpack_public_path__ + "static/media/pro-elevate-pyl-2.7cd87f5f.png";